import React from "react";
import Dropdown, { DropdownItem as IDropdownItemNew } from "./dropdown";
import { CURRENCIES } from "../../assets/interfaces";
import classNames from "classnames";
import NigeriaFlag from "@/assets/icons/flags/nigeria.svg";
import GhanaFlag from "@/assets/icons/flags/ghana.svg";
import SAFlag from "@/assets/icons/flags/south-africa.svg";
import KEFlag from "@/assets/icons/flags/kenya.svg";
import USAFlag from "@/assets/icons/flags/united-states.svg";
import BritainFlag from "@/assets/icons/flags/britain.svg";
import CanadaFlag from "@/assets/icons/flags/canada.svg";

interface Props {
  currencies: CURRENCIES[];
  setCurrency: (currency: CURRENCIES) => void;
  selected: CURRENCIES;
  noBg?: boolean;
}

const CurrencySwitcher: React.FC<Props> = ({ currencies, setCurrency, selected, noBg = false }) => {
  const dropdownItems: IDropdownItemNew[] = currencies
    .filter((curr) => curr !== selected)
    .map((curr) => ({
      text: curr,
      link: undefined,
      onClick: () => setCurrency(curr),
      icon: <figure className="h-4 w-4 rounded-full overflow-hidden">{currencyMap[curr].icon()}</figure>,
    }));

  if(currencies.length < 2){
    return (
      <>
        <button
          className={classNames("h-8 sm:h-9 flex items-center dropdown-toggle relative", {
            "rounded-30 border border-grey-outline no-outline px-2 border-opacity-50 bg-grey-fields-100": !noBg,
          })}
        >
            <span className="inline-flex items-center gap-1.5 mr-0.5 text-1xs md:text-sm text-black-secondary font-medium">
                <figure className="h-4 w-4 rounded-full overflow-hidden">{currencyMap[selected].icon()}</figure>
                {selected}
            </span>
       </button>
      </>
    )
  }

  return (
    <Dropdown items={dropdownItems} vPosition="BOTTOM" tiny>
      {(isOpen) => (
        <button
          className={classNames("h-8 sm:h-9 flex items-center dropdown-toggle relative", {
            "rounded-30 border border-grey-outline no-outline px-2 border-opacity-50 bg-grey-fields-100": !noBg,
          })}
        >
            <span className="inline-flex items-center gap-1.5 mr-0.5 text-1xs md:text-sm text-black-secondary font-medium">
              <figure className="h-5 w-5 rounded-full overflow-hidden">{currencyMap[selected].icon()}</figure>
              {selected}
            </span>
          {/* prettier-ignore */}
          <svg viewBox="0 0 20 20" fill="none" className={classNames(`transition-transform text-dark transform flex-shrink-0 w-4 sm:w-5`, { 'rotate-180': isOpen})}>
            <path d="M15 7.5L10 12.5L5 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      )}
    </Dropdown>
  );
};

const CURRENCY_FLAG_MAP = {
  [CURRENCIES.EUR]: "🇪🇺",
  [CURRENCIES.GBP]: "🇬🇧",
  [CURRENCIES.NGN]: "🇳🇬",
  [CURRENCIES.GHC]: "🇬🇭",
  [CURRENCIES.USD]: "🇺🇸",
  [CURRENCIES.ZAR]: "🇿🇦",
  [CURRENCIES.KES]: "🇰🇪",
  [CURRENCIES.CAD]: "🇨🇦",
};

const currencyMap = {
  NGN: {
    fullName: "Nigerian Naira",
    icon: NigeriaFlag,
  },
  GHS: {
    fullName: "Ghanaian Cedi",
    icon: GhanaFlag,
  },
  USD: {
    fullName: "US Dollar",
    icon: USAFlag, // Replace with the correct icon for USD
  },
  GBP: {
    fullName: "Great Britain Pound",
    icon: BritainFlag, // Replace with the correct icon for USD
  },
  CAD: {
    fullName: "Canadian Dollar",
    icon: CanadaFlag, // Replace with the correct icon for USD
  },
  ZAR: {
    fullName: "South African Rand",
    icon: SAFlag,
  },
  KES: {
    fullName: "Kenyan Shilling",
    icon: KEFlag,
  },
};

export default CurrencySwitcher;
